import { URL_AUTOGESTION } from 'config'
import { MEMBERSHIP_STATUS } from 'constants/subscriptions'

const { ACTIVE, SUSPENDED, DELAYED } = MEMBERSHIP_STATUS

export const hasActiveMembership = (products) => {
  if (!products?.length) return false

  return products.some(
    (element) =>
      element.product === 'memberships' &&
      (element.status === ACTIVE || element.status === DELAYED)
  )
}

export const hasSuspendedMembership = (products) => {
  if (!products?.length) return false

  return products.some(
    (element) =>
      element.product === 'memberships' && element.status === SUSPENDED
  )
}

export const hasDelayedMembership = (products) => {
  if (!products?.length) return false

  return products.some(
    (element) => element.product === 'memberships' && element.status === DELAYED
  )
}

export const getMembershipStatus = (products) => {
  if (!products) return

  const membershipProduct = products.find(
    (element) => element.product === 'memberships'
  )

  if (membershipProduct) {
    if (
      membershipProduct.status === ACTIVE ||
      membershipProduct.status === DELAYED ||
      membershipProduct.status === SUSPENDED
    ) {
      return membershipProduct.status
    }
  }

  return null
}

export const advanceIsDisabled = (line) => {
  if (line?.credit_line_expiration) {
    const expirationTime = new Date(line?.credit_line_expiration).getTime()
    const nowTime = new Date().getTime()

    if (nowTime < expirationTime && line?.credit_line_remaining_amount === 0) {
      return true
    }
  }

  return false
}

// Redirect to autogestion
export const navigatePayMembership = (documentNumber) => {
  window.open(`${URL_AUTOGESTION}${documentNumber}/membresia`)
}
